import React from "react";
import { connect } from "react-redux";
import Navigation from "./Navigation";
import { changeStep } from "../../modules/results/actions";

function NavigationContainer(props) {
  const { protocol, hostname, pathname } = window.location;
  const shareUrl = `${protocol}//${hostname}${pathname.replace(
    "/results",
    ""
  )}`;

  return <Navigation {...props} shareUrl={shareUrl} />;
}

function mapStateToProps(state) {
  return {
    language: state.preference.language,
    result: state.results.result,
    drivers: state.results.drivers,
    highlight: state.results.highlight,
    step: state.results.step
  };
}

const mapActionsToProps = {
  changeStep
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(NavigationContainer);



// WEBPACK FOOTER //
// ./src/pages/SurveyResults/NavigationContainer.js